const dynamicMinHeight = () => {
  const dynamicMinHeightElementGroups = {};

  const dynamicMinHeightElements = document.querySelectorAll('.js-dynamic-min-height');

  dynamicMinHeightElements.forEach((element) => {
    const parent = element.closest('.c-carousel');
    const parentKey = parent.classList.toString();

    if (!dynamicMinHeightElementGroups[parentKey]) {
      dynamicMinHeightElementGroups[parentKey] = [];
    }

    dynamicMinHeightElementGroups[parentKey].push(element);
  });

  Object.entries(dynamicMinHeightElementGroups).forEach(([groupKey, group]) => { // eslint-disable-line @typescript-eslint/no-unused-vars, max-len
    let maxHeight = 0;

    group.forEach((element) => {
      const elementHeight = element.clientHeight;

      if (elementHeight > maxHeight) {
        maxHeight = elementHeight;
      }
    });

    group.forEach((element) => {
      const currentElement = element;
      currentElement.style.minHeight = `${maxHeight}px`;
    });
  });
};

export default dynamicMinHeight;
